import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <span className="logo-text">HYPERION AI</span>
        </Link>

        {/* Mobile menu button */}
        <div className="mobile-menu-button" onClick={toggleMenu}>
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Navigation links */}
        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/solutions" className="nav-link">Solutions</Link>
            </li>
            <li className="nav-item">
              <Link to="/about-team" className="nav-link">Experience</Link>
            </li>
            <li className="nav-item">
              <Link to="/blogs" className="nav-link">Insights</Link>
            </li>
            <li className="nav-item">
              <Link to="/about-company" className="nav-link">Careers</Link>
            </li>
            <li className="nav-item">
              <Link to="/about-team" className="nav-link">About</Link>
            </li>
          </ul>
          
          <Link to="/contact-us" className="nav-cta-button">
            Get In Touch
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
